import React from 'react';

interface FooterLinkProps {
  href: string;
  children: React.ReactNode;
  external?: boolean;
  underline?: boolean;
}

export const FooterLink: React.FC<FooterLinkProps> = ({ 
  href, 
  children, 
  external = false,
  underline = false 
}) => {
  const linkClasses = `!text-white text-base font-medium leading-[22.4px] hover:text-[#C3B89F] transition-colors font-['Figtree'] ${underline ? 'underline' : ''}`;
  
  return (
    <div className="pb-[16px] flex items-center">
      <a 
        href={href}
        className={linkClasses}
        {...(external && { target: '_blank', rel: 'noopener noreferrer' })}
      >
        {children}
      </a>
    </div>
  );
};
